import React, { createContext, useContext } from "react";
// import { getDrawingData } from "../../DrawingRegisterTab/api";
import { createMrq } from "../api";
import { onAddingNewDrawing } from "./handleAddingNewDrawing";
import { getObject } from "./ConsolidateMaterials";
import { handleComparing } from "./handleComparing";
import { getHashdata } from "../../../../../../../../components/Tabs/Utils/hashFunctions";
import { ifSoftwareValidation } from "./ifSoftwareValidation";
import { useEffect } from "react";
import { ifDrawingUrl } from "./ifDrawingUrl";
import ColoredSnackbar from "../../../../../../../../components/ColoredSnakebar";
import { useBOMDashboardContext } from "../../BOMDashboard.context";
import { useMcsContext } from "../../../MCS.context";

const DrawingBomContext = createContext();

export const useDrawingBomContext = () => useContext(DrawingBomContext);

let currentDate = new Date();
const offset = currentDate.getTimezoneOffset();
currentDate = new Date(currentDate.getTime() - offset * 60 * 1000);

function DrawingBomProvider({ children }) {
  const { plant, updatePlantAfterCreateMrq, mrqList } = useMcsContext();

  const {
    project,
    // setMrqSelection,
    setCurrentTab,
    setSelectedDrawings,
    updateProjectAfterCreateMrq,
  } = useBOMDashboardContext();

  const selectedDrawings = project?.selectedDrawings || [];

  const [selectionMaterials, setSelectionMaterials] = React.useState({});
  const [consolidatedMaterials, setConsolidatedMaterials] = React.useState([]);
  // selectionMaterials: {drawingId: [materials], }
  const [openConsolidateModal, setOpenConsolidateModal] = React.useState(false);
  const [openChangeOrderModal, setOpenChangeOrderModal] = React.useState(false);
  const [openAddSrvModal, setOpenAddSrvModal] = React.useState(false);
  const [openCompare, setOpenCompare] = React.useState(false);
  const [openMtr, setOpenMtr] = React.useState(false);

  const [generatingData, setGeneratingData] = React.useState([]);

  const [isMrqFormVisible, setIsMrqFormVisible] = React.useState(false);
  const [mrqMaterials, setMrqMaterials] = React.useState([]);

  const initialMrqDetails = {
    plantId: plant.id,
    plantName: plant.name || "",
    mrqDate: currentDate.toISOString().split("T")[0],
  };
  const [mrqDetails, setMrqDetails] = React.useState(initialMrqDetails);
  const [selectedMrqDoc, setSelectedMrqDoc] = React.useState("");
  const [comparedDrawing, setComparedDrawing] = React.useState({});
  const [currentResponse, setCurrentResponse] = React.useState({});

  // If Validation from software
  const drawingId = getHashdata(window.location.hash, "drawing-id");
  const isValidate = getHashdata(window.location.hash, "validate");

  console.log("drawing-id", drawingId, isValidate);

  const showDrawingById = async (drawingId) => {
    console.log("-----------------new Drawing :", drawingId);
    await ifDrawingUrl({
      drawingId,
      selectedDrawings,
      setSelectedDrawings,
    });
  };

  useEffect(() => {
    const showDrawingByUrl = async () => {
      drawingId && !isValidate && showDrawingById(drawingId);
    };

    const getValidation = async () => {
      drawingId &&
        isValidate &&
        (await ifSoftwareValidation({
          drawingId,
          setOpenCompare,
          setComparedDrawing,
          showDrawingById,
          setCurrentResponse,
        }));
    };

    showDrawingByUrl();
    getValidation();
  }, [drawingId]);

  // Deal With Drawings
  const handleAddingNewDrawing = async ({ drawing }) => {
    // if (selectedDrawings.find((d) => d.id === drawing.id)) {
    //   alert("Drawing is Already selected !");
    // } else {
    await onAddingNewDrawing({
      drawing,
      selectedDrawings,
      setSelectedDrawings,
    });
    // }
  };

  const removeSelectedDrawing = (id) => {
    setSelectedDrawings(
      selectedDrawings.filter((drawing) => drawing.id !== id),
    );
    setSelectionMaterials[id] = [];
    setSelectionMaterials({ ...setSelectionMaterials });
  };

  const onRemoveAll = () => {
    setSelectedDrawings([]);
    setSelectionMaterials({});
  };

  // Deal With ChangeOrder Materials
  const handleOpenChangeOrderModal = () => setOpenChangeOrderModal(true);
  const handleCloseChangeOrderModal = () => setOpenChangeOrderModal(false);

  function onClickChangeOrder() {
    const isConsolidated = consolidateMaterials();

    if (isConsolidated) {
      handleOpenChangeOrderModal(true);
    }
  }

  // Deal With Consolidate Materials
  const handleOpenConsolidateModal = () => setOpenConsolidateModal(true);
  const handleCloseConsolidateModal = () => setOpenConsolidateModal(false);

  const obj = getObject(consolidatedMaterials);

  const consolidatedMaterialsData = Object.values(obj).map((m) => {
    const materials = consolidatedMaterials.filter(
      (material) => material.materialCode === m.materialCode,
    );
    return { ...m, materials };
  });

  // const consolidatedDescriptionMaterialsData = Object.values(obj).map((m) => {
  //   const materials = consolidatedMaterials.filter(
  //     (material) =>
  //       material.description === m.description &&
  //       material.costCode === m.costCode
  //   );
  //   // console.log({ materials });
  //   return { ...m, materials };
  // });

  const consolidatedTaggedMaterialsData = Object.values(obj).map((m) => {
    const materials = consolidatedMaterials.filter(
      (material) => material.description === m.description,
    );
    return {
      ...m,
      materials,
      description: m.description
        ? m.description
        : materials[0].taggedMaterial.component +
          " " +
          materials[0].taggedMaterial.size,
    };
  });

  const initialGeneratingData = consolidatedMaterialsData?.map((m) => ({
    softwareId: m.softwareId,
    materialNo: m.materialNo,
    actualTotalWeight: m.totalWtInKgs,
    materials: m.materials,
  }));

  function changeSelectionMaterials(drawingSelectedMaterials) {
    // console.log("drawingSelectedMaterials context", drawingSelectedMaterials);
    setSelectionMaterials({
      ...selectionMaterials,
      ...drawingSelectedMaterials,
    });
  }

  function consolidateMaterials() {
    let materials = [];
    Object.values(selectionMaterials).forEach((val) => {
      val.forEach((material) => materials.push(material));
    });

    const mappedMaterials = Object.values(getObject(materials)).map((m) => ({
      ...m,
      materials: materials.filter(
        (material) =>
          material.description === m.description &&
          material.costCode === m.costCode,
      ),
    }));

    if (materials[0]) {
      setMrqMaterials(mappedMaterials);
      setConsolidatedMaterials(materials);

      return true;
    } else {
      alert("No materials selected");
      return false;
    }
  }

  function onConsolidate() {
    setIsMrqFormVisible(false);
    setMrqDetails(initialMrqDetails);
    setGeneratingData(initialGeneratingData);

    const isConsolidated = consolidateMaterials();

    if (isConsolidated) {
      handleOpenConsolidateModal(true);
    }
  }

  function onReviseMrq() {
    return consolidateMaterials();
  }

  // Deal With Add Srv Materials
  const handleOpenAddSrvModal = () => setOpenAddSrvModal(true);
  const handleCloseAddSrvModal = () => setOpenAddSrvModal(false);

  function onAddSrv() {
    const isConsolidated = consolidateMaterials();

    if (isConsolidated) {
      console.log({ consolidatedMaterials });
      handleOpenAddSrvModal(true);
    }
  }

  // Deal with comparing
  const handleOpenCompareModal = () => setOpenCompare(true);
  const handleCloseCompareModal = () => setOpenCompare(false);

  const onCompare = () => {
    if (selectedDrawings.length >= 2) {
      handleOpenCompareModal();

      const comparedDrawingResults = handleComparing({
        selectedDrawings,
        handleCloseCompareModal,
      });
      setComparedDrawing(comparedDrawingResults);
    } else {
      alert("Please select at least two Revisions to compare");
    }
  };

  const handleOpenMtrModal = () => setOpenMtr(true);
  const handleCloseMtrModal = () => setOpenMtr(false);

  const onClickMtr = () => {
    if (!selectedDrawings.length) {
      alert("Please select at least two Revisions to compare");
    } else {
      handleOpenMtrModal();
    }
  };

  // Deal With Create MRQ
  const onClickAddMrq = () => {
    setIsMrqFormVisible(true);
  };

  const onMrqDetailsChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    // console.log(name, value);
    setMrqDetails({ ...mrqDetails, [name]: value });
  };

  const onCreateMrq = async () => {
    if (mrqList?.find((m) => m.mrqNumber === mrqDetails.mrqNumber)) {
      alert("MRQ Number exists, change the MRQ Number.");
    } else {
      const createdMrq = {
        ...mrqDetails,
        document: selectedMrqDoc,
        selectedDrawings,
        mrqMaterials: mrqMaterials.map((m) => {
          return {
            ...m,
            unit: consolidatedMaterials?.[0].tagNumber ? "Nos" : "Ft",
          };
        }),
      };
      console.log("createdMrq", createdMrq);
      if (!createdMrq.mrqNumber) {
        alert("Please Insert MRQ Number.");
      } else {
        const res = await createMrq({ createdMrq });

        if (res?.mrq?.id) {
          setOpenConsolidateModal(false);

          updatePlantAfterCreateMrq(res);
          updateProjectAfterCreateMrq(res);
        }
      }
    }
  };

  const onUpdateRevisedMrq = async ({ mrq, drawings }) => {
    const createdMrq = {
      ...mrq,
      plantName: plant.name,
      selectedDrawings,

      mrqMaterials: mrqMaterials.map((m) => {
        return {
          ...m,
          unit: consolidatedMaterials?.[0].tagNumber ? "Nos" : "Ft",
        };
      }),
    };
    console.log("createdMrq", createdMrq);
    if (!createdMrq.mrqNumber) {
      alert("Please Insert MRQ Number.");
    } else {
      const res = await createMrq({ createdMrq });

      if (res?.mrq?.id) {
        setOpenConsolidateModal(false);

        updatePlantAfterCreateMrq(res);
        updateProjectAfterCreateMrq(res);
      }
    }
  };

  return (
    <DrawingBomContext.Provider
      value={{
        handleAddingNewDrawing,
        selectedDrawings,
        removeSelectedDrawing,
        onRemoveAll,

        selectionMaterials,
        setSelectionMaterials,

        onConsolidate,
        openConsolidateModal,
        handleCloseConsolidateModal,
        consolidatedMaterials,
        mrqMaterials,
        setMrqMaterials,

        onClickChangeOrder,
        openChangeOrderModal,
        handleCloseChangeOrderModal,

        // consolidatedDescriptionMaterialsData,
        consolidatedTaggedMaterialsData,
        consolidatedMaterialsData,
        generatingData,
        setGeneratingData,
        initialGeneratingData,
        onReviseMrq,
        onUpdateRevisedMrq,

        onAddSrv,
        openAddSrvModal,
        setOpenAddSrvModal,
        handleCloseAddSrvModal,
        changeSelectionMaterials,

        onCompare,
        openCompare,
        setOpenCompare,
        handleCloseCompareModal,
        comparedDrawing,

        onClickMtr,
        openMtr,
        handleCloseMtrModal,

        isMrqFormVisible,
        onClickAddMrq,
        mrqDetails,
        onMrqDetailsChange,
        selectedMrqDoc,
        setSelectedMrqDoc,
        onCreateMrq,
      }}
    >
      {children}

      <ColoredSnackbar
        open={currentResponse.state}
        severity={currentResponse.state}
        onClose={() => setCurrentResponse({})}
        message={currentResponse.message}
      />
    </DrawingBomContext.Provider>
  );
}

export { DrawingBomProvider, DrawingBomContext };
